import type { BlendMode } from '../editor/types';
import { DEFAULT_DESIGN_OPACITY } from '../../shared/catalog';

export type DesignCategory = string;

export interface TattooDesign {
  id: string;
  name: string;
  category: DesignCategory;
  categories?: DesignCategory[];
  categoryIds?: string[];
  thumbnail: string;
  asset: string;
  defaultBlend: BlendMode;
  recommendedOpacity: number;
  whiteRemovalThreshold?: number;
  tags?: string[];
  artistId?: string | null;
  displayPriority?: number;
  active?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

const asset = (name: string) => `/tattoos/${name}`;

export const tattooDesigns: TattooDesign[] = [
  { id: 'resting-cat', name: 'Resting Cat', category: 'Japanese', categories: ['Japanese'], thumbnail: asset('IMG_7850.PNG'), asset: asset('IMG_7850.PNG'), defaultBlend: 'multiply', recommendedOpacity: DEFAULT_DESIGN_OPACITY, displayPriority: 0 },
  { id: 'guardian-cat', name: 'Guardian Cat', category: 'Japanese', categories: ['Japanese'], thumbnail: asset('IMG_7851.PNG'), asset: asset('IMG_7851.PNG'), defaultBlend: 'multiply', recommendedOpacity: DEFAULT_DESIGN_OPACITY, displayPriority: 1 },
  { id: 'red-lantern', name: 'Red Lantern', category: 'Japanese', categories: ['Japanese'], thumbnail: asset('IMG_7854.PNG'), asset: asset('IMG_7854.PNG'), defaultBlend: 'multiply', recommendedOpacity: DEFAULT_DESIGN_OPACITY, displayPriority: 2 },
  { id: 'urban-helmet', name: 'Urban Helmet', category: 'Illustrative', categories: ['Illustrative'], thumbnail: asset('IMG_7855.PNG'), asset: asset('IMG_7855.PNG'), defaultBlend: 'multiply', recommendedOpacity: DEFAULT_DESIGN_OPACITY, displayPriority: 3 },
  { id: 'oni-mask', name: 'Oni Mask', category: 'Blackwork', categories: ['Blackwork'], thumbnail: asset('IMG_7858.PNG'), asset: asset('IMG_7858.PNG'), defaultBlend: 'multiply', recommendedOpacity: DEFAULT_DESIGN_OPACITY, displayPriority: 4 },
  { id: 'focus-forward', name: 'Focus Forward', category: 'Lettering', categories: ['Lettering'], thumbnail: asset('IMG_7859.PNG'), asset: asset('IMG_7859.PNG'), defaultBlend: 'multiply', recommendedOpacity: DEFAULT_DESIGN_OPACITY, displayPriority: 5 },
  { id: 'remember-why', name: 'Remember Why', category: 'Lettering', categories: ['Lettering'], thumbnail: asset('IMG_7860.PNG'), asset: asset('IMG_7860.PNG'), defaultBlend: 'multiply', recommendedOpacity: DEFAULT_DESIGN_OPACITY, displayPriority: 6 },
  { id: 'dreams-real', name: 'Dreams Are Real', category: 'Lettering', categories: ['Lettering'], thumbnail: asset('IMG_7861.PNG'), asset: asset('IMG_7861.PNG'), defaultBlend: 'multiply', recommendedOpacity: DEFAULT_DESIGN_OPACITY, displayPriority: 7 },
];

export const designCategories: DesignCategory[] = ['All', 'Japanese', 'Illustrative', 'Lettering', 'Blackwork'];
